import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";
import { HashRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import Favicon from 'react-favicon';
import { BRAND_FAVICON } from "../brand";

import Backdrop from "./layout/Backdrop";
import LandingPage from "./layout/LandingPage";
import Login from "./accounts/Login";
import ForgotPassword from "./accounts/ForgotPassword";
import ResetPassword from "./accounts/ResetPassword";
import OAuthCallback from "./accounts/OAuthCallback";
import Register from "./accounts/register/Registration";
import Verified from "./accounts/register/Verified";
import Settings from "./settings/Settings";
// import Projects from "./projects/Projects";
// import ProjectCreate from "./projects/ProjectCreate";
import PrivateRoute from "./common/PrivateRoute";
import NotFound from "./common/NotFound";
// import Modal from "./common/Modal/Modal";
// import Contract from "./contract/Contract"
// import Invoices from "./invoices/Invoices";
// import Invoice from "./invoices/Invoice";
// import InvoiceEdit from "./invoices/InvoiceEdit";
import People from "./people/People";
import Alerts from "./layout/Alerts";
import Dashboard from "./dashboard/Dashboard";
import Navbar from "./navigation/Navbar";
import Sidebar from "./navigation/sidebar/Sidebar";
import ExternalAction from "./accounts/externalAction/ExternalAction";
import ManagementDrops from "../components/navigation/management/ManagementDrops";
import ProjectList from "./project/ProjectList";
import ProjectSingle from "./project/ProjectSingle";
import InvoiceList from "./invoice/InvoiceList";
import InvoiceSingle from "./invoice/InvoiceSingle";
import WorkflowSingle from "./workflow/WorkflowSingle";
import WorkflowList from "./workflow/WorkflowList";
import QuoteList from "./quote/QuoteList";
import QuoteSingle from "./quote/QuoteSingle";

import { Provider } from "react-redux";
import store from "../store";
import { loadUser } from "../actions/auth";


class App extends Component {

	componentDidMount() {
		store.dispatch(loadUser());
	}
	
	render() {
		return (
			<Provider store={store}>
                <Alerts />
					<Router>
						<Fragment>
							<Backdrop />
								<div className="viewport">
									<Navbar />
									{/* <Modal modalProps={this.modalProps} /> */}
									<div className="mid-section">
										<Sidebar />
										<Switch>
											
											<Route exact path="/" component={LandingPage} />
											<Route exact path="/login" component={Login} />
											<Route exact path="/login/:email" component={Login} />
											<Route exact path="/forgot-password" component={ForgotPassword} />
											<Route exact path="/reset-password/:uidb64/:token" component={ResetPassword} />
											<Route exact path="/oauth-callback" component={OAuthCallback} />
											<Route exact path="/register" component={Register} />
											<Route exact path="/register/:email" component={Register} />
											<Route exact path="/register/:email/:invite" component={Register} />
											<Route exact path="/activate-account/:uidb64/:token" component={Verified} />
											<Route exact path="/ext-action/:uidb64/:token/:response" component={ExternalAction} />
											<PrivateRoute exact path="/dashboard" component={Dashboard} />
											<PrivateRoute exact path="/settings/view" component={Settings} />
											<PrivateRoute exact path="/settings/user-edit" component={Settings} />
											<PrivateRoute exact path="/settings/company-edit" component={Settings} />
											<PrivateRoute exact path="/settings/approval-workflows" component={Settings} />
											<PrivateRoute exact path="/settings/stage-names" component={Settings} />
											<PrivateRoute exact path="/people" component={People} />
											<PrivateRoute exact path="/quotes/list" component={QuoteList} />
											<PrivateRoute exact path="/quote/:mode/:id" component={QuoteSingle} />
                                            <>
                                                <div className="page-wrapper">
                                                    <PrivateRoute path="/mng" component={ManagementDrops} />
                                                
                                                    <PrivateRoute exact path="/mng/projects/:mode" component={ProjectList} />
                                                    <PrivateRoute exact path="/mng/project/:mode/:id" component={ProjectSingle} />

                                                    <PrivateRoute exact path="/mng/workflows/:mode" component={WorkflowList} />
                                                    <PrivateRoute exact path="/mng/workflow/:mode/:id" component={WorkflowSingle} />

                                                    <PrivateRoute exact path="/mng/invoices/:mode" component={InvoiceList} />
                                                    <PrivateRoute exact path="/mng/invoice/:mode/:id" component={InvoiceSingle} />
                                                </div>
                                            </>
											<PrivateRoute exact path="/people" component={People}/>
											<Route component={NotFound} />
										</Switch>						
									</div>
								</div>
						</Fragment>
					</Router>
			</Provider>
		)
	}
}

ReactDOM.render(
    <>
        <Favicon url={BRAND_FAVICON} />
        <App />
    </>
    , document.getElementById("app"));

